var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	58052: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_pnpm_angular_core_21_2_16__angular_compiler_21_2_16_rxjs_7_8_2_zone_js_0-56d0e1"), __webpack_require__.e("default-node_modules_pnpm_angular_core_21_2_16__angular_compiler_21_2_16_rxjs_7_8_2_zone_js_0-cfadef"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_pnpm_angular_core_21_2_16__angular_compiler_21_2_16_rxjs_7_8_2_zone_js_0_15_1_no-90e285")]).then(() => (() => (__webpack_require__(/*! @angular/core */ 87622))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~21.2.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	7909: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_pnpm_angular_platform-browser_21_2_16__angular_animations_21_2_16__angul-0cba85"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-node_modules_pnpm_angular_platform-browser_21_2_16__angular_animations_21_2_16__angul-02ed48")]).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 98952))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~21.2.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	85215: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_pnpm_angular_common_21_2_16__angular_core_21_2_16__angular_compiler_21_2-393812")]).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 41966))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~21.2.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	33480: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-node_modules_pnpm_angular_router_21_2_16__angular_common_21_2_16__angular_core_21_2_1-975f52")]).then(() => (() => (__webpack_require__(/*! @angular/router */ 41970))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~21.2.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	},
	80334: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_pnpm_angular_platform-browser_21_2_16__angular_animations_21_2_16__angul-0cba85"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_animations_browser_angular_animations_browser"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @angular/platform-browser/animations */ 35231))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~21.2.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser/animations",

	},
	78874: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_azure_msal-browser_azure_msal-browser"), __webpack_require__.e("default-libs_auth-shared_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @org/auth-shared */ 75126))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@org/auth-shared",

	},
	85424: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_pnpm_rxjs_7_8_2_node_modules_rxjs_dist_esm_internal_operators_auditTime_-6b9e6f"), __webpack_require__.e("node_modules_pnpm_rxjs_7_8_2_node_modules_rxjs_dist_esm_index_js")]).then(() => (() => (__webpack_require__(/*! rxjs */ 82328))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.8.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	57980: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_pnpm_rxjs_7_8_2_node_modules_rxjs_dist_esm_internal_operators_auditTime_-6b9e6f"), __webpack_require__.e("node_modules_pnpm_rxjs_7_8_2_node_modules_rxjs_dist_esm_operators_index_js")]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 23222))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.8.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",

	},
	4256: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 65349))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~21.2.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",

	},
	60826: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 87303))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~21.2.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",

	},
	76899: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-node_modules_pnpm_angular_common_21_2_16__angular_core_21_2_16__angular_compiler_21_2-f2763e")]).then(() => (() => (__webpack_require__(/*! @angular/common */ 15565))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~21.2.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	25214: {
		fallback: () => (__webpack_require__.e("default-node_modules_pnpm_angular_animations_21_2_16__angular_core_21_2_16__angular_compiler_-b1e702").then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 36427))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~21.2.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations/browser",

	},
	20269: {
		fallback: () => (__webpack_require__.e("node_modules_pnpm_azure_msal-browser_5_12_0_node_modules_azure_msal-browser_dist_index_mjs").then(() => (() => (__webpack_require__(/*! @azure/msal-browser */ 15915))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.8.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@azure/msal-browser",

	},
	31228: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_pnpm_angular_core_21_2_16__angular_compiler_21_2_16_rxjs_7_8_2_zone_js_0-56d0e1"), __webpack_require__.e("default-node_modules_pnpm_angular_core_21_2_16__angular_compiler_21_2_16_rxjs_7_8_2_zone_js_0-cfadef"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 63848))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~21.2.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",

	},
	30398: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-libs_ui-shared_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @org/ui-shared */ 62754))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@org/ui-shared",

	},
	41591: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @ngrx/signals/rxjs-interop */ 85938))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/signals/rxjs-interop",

	},
	24165: {
		fallback: () => (__webpack_require__.e("default-node_modules_pnpm_ngrx_signals_21_1_1__angular_core_21_2_16__angular_compiler_21_2_16-de4e7d").then(() => (() => (__webpack_require__(/*! @ngrx/signals */ 34176))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/signals",

	},
	43632: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @ngrx/operators */ 91107))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/operators",

	},
	32264: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_pnpm_azure_msal-angular_5_2_6__azure_msal-browser_5_12_0_rxjs_7_8_2_node-e2f904")]).then(() => (() => (__webpack_require__(/*! @azure/msal-angular */ 50871))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.2.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@azure/msal-angular",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"default-webpack_sharing_consume_default_angular_core_angular_core": [
		58052
	],
	"default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser": [
		7909
	],
	"default-webpack_sharing_consume_default_angular_common_http_angular_common_http": [
		85215
	],
	"default-webpack_sharing_consume_default_angular_router_angular_router": [
		33480
	],
	"apps_angular_with-remotes_shell_src_bootstrap_ts": [
		80334,
		78874
	],
	"default-webpack_sharing_consume_default_rxjs_rxjs": [
		85424
	],
	"default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators": [
		57980
	],
	"default-node_modules_pnpm_angular_core_21_2_16__angular_compiler_21_2_16_rxjs_7_8_2_zone_js_0-cfadef": [
		4256,
		60826
	],
	"default-webpack_sharing_consume_default_angular_common_angular_common": [
		76899
	],
	"default-webpack_sharing_consume_default_angular_animations_browser_angular_animations_browser": [
		25214
	],
	"default-webpack_sharing_consume_default_azure_msal-browser_azure_msal-browser": [
		20269
	],
	"default-libs_auth-shared_src_index_ts": [
		31228,
		30398,
		41591,
		24165,
		43632,
		32264
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}